<template>
    <div>
        
        <div id="land-back">
            <div id="main-row">
                <div id="main-cont">
                    <div id="login-container">
                        <center>
                            <logo id="logo-login"></logo>
                        </center>
                        <h1 id="login-container-title">Bienvenidos a la nueva forma de aprender</h1>
                        <p id="land-p">Todo el conocimiento esta aquí. Tú eliges cuando, donde y como estudiar</p>
                        <label id="label" for="">Rut</label>
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            content="Ingrese su rut sin puntos, con guión como el ejemplo">
                            <span id="rut-info" class="el-icon-info" slot="reference"></span>
                        </el-popover>
                        <el-input @keyup.enter.native="login" id="login-container-input" v-model="input.rut" placeholder="Ej: 12365485-5"></el-input>
                        <label id="label" for="">Contraseña</label>
                        <el-input @keyup.enter.native="login" id="login-container-input" v-model="input.password" label="" type="password"></el-input>
                        <el-button id="btn-login2" v-loading="loading" class="btn-login btn-cmpc" size="mini" v-on:click="login()">Ingresar</el-button>   
                    </div>
                </div>
            </div>
            <div id=land-content>
                <section>
                    <div id="our-plataform">
                        <h1 id="main-title">Nuestra Plataforma</h1>
                        <p id="land-p">Safety Academy forma parte de la plaforma LifeOn, ERP de gestión de riesgos  que integra la gestión de seguridad, operaciones y recursos humanos, para producir de manera segura e incrementar la competitividad, innovación y sustentabilidad de la empresa. </p>
                    </div>
                </section>

                <section>
                    <el-row>
                        <el-col :xs="24" :md="8">
                            <div id="features">
                                <img src="../../assets/images/24-hours.svg" alt="" width="60px">
                                <h1 id="main-subtitle">Accesibilidad y Disponibildad</h1>
                                <p id="land-p">Conocimiento especializado, con acceso desde cualquier lugar del mundo 24/7</p>
                            </div>
                        </el-col>
                        <el-col :xs="24" :md="8">
                            <div id="features">
                                <img src="../../assets/images/research.svg" alt="" width="60px">
                                <h1 id="main-subtitle">Control de Competencias</h1>
                                <p id="land-p">Validación y Seguimiento de las Competencias de tu Equipo 24/7</p>
                            </div>
                        </el-col>
                        <el-col :xs="24" :md="8">
                            <div id="features">
                                <img src="../../assets/images/file.svg" alt="" width="40px">
                                <h1 id="main-subtitle">Certificados</h1>
                                <p id="land-p">Obtén reconocimiento por tu apredizaje  y comparte tu éxito con amigos, compañeros y empleadores.</p>
                            </div>
                        </el-col>
                    </el-row>
                </section>
            </div>
                <section id="courses-section">
                    <div id="some-courses">
                        <p id="land-p">Conoce</p>
                        <h1 id="main-title">Alguno de nuestros cursos</h1>
                        <br>
                        <el-row>
                            <el-col :xs="24" :sm="12" :md="12">
                                <div id="img-container">
                                    <center>
                                        <h1 id="course-land" >
                                            Riesgos de Conduccón de Transportista 
                                        </h1>
                                    </center>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <div id="img-container">
                                    <center>
                                        <h1 id="course-land">
                                            Investigación de Accidentes 
                                        </h1>
                                    </center>
                                </div>
                            </el-col>
                            
                        </el-row>
                        <br>
                        <a href="#">Ver todos <span class="el-icon-arrow-right"></span></a>
                    </div>
                </section>
            <div id=land-content>
                <section>
                    <div id="contact">
                        <h1 id="main-title">Contáctanos</h1>
                        <br>
                        <el-row>
                            <el-col :xs="24" :md="12" id="contact-input">
                                <el-input v-model="name" placeholder="Nombre"></el-input>   
                            </el-col>
                            <el-col :xs="24" :md="12" id="contact-input">
                                <el-input v-model="email" placeholder="E-Mail"></el-input> 
                            </el-col>
                            <el-col :md="24" id="contact-input">
                               <el-input type="textarea" :rows="5" v-model="mesage" placeholder="Mensaje"></el-input> 
                            </el-col>
                            <el-col :md="24" id="contact-input">
                              <el-button class="btn-cmpc" icon="el-icon-arrow-right" >Enviar</el-button>
                            </el-col>
                        </el-row>
                        <br>
                        <div id="support">
                            <p id="land-p">¿Necesitas ayuda?</p>
                            <div id="phone">
                                <h1 id="phone-number">+56 9 74995325</h1>
                            </div>
                            <p id="land-phone">También puede comunicarse con nosotros escribiendo directamente a </p>
                            <a href="mailto:soporte@cursos.softys.lifeon.cl">soporte@cursos.softys.lifeon.cl</a>
                            <p id="land-phone">Horario atención telefónica: Lunes a Viernes de 9:00 a 19:00</p>
                        </div>
                        
                    </div>
                </section>

                <footer>
                    <div id="footer">
                        CopyRight Safetyclub 2019
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import logoAzul from '@/components/logo/logoAzul'
import axios from 'axios'
import jwt_decode from 'jwt-decode'
import { getCompanies } from '@/requests/companies'
import { getCourses } from '@/requests/courses'
import { Request } from 'fetchboi'
import { baseAPIRoot } from '@/config/index.config'
import { userAPIRoot } from '@/config/users.config'
export default {
    components: { logo: logoAzul },
    data() {
        return {
            loading: false,
            name: '',
            email: '',
            mesage: '',
            input: {
                rut: "",
                password: "",
                user: [],
            }
        }
    },
    methods: {
        login() {
            this.loading = true
            this.input.rut = this.input.rut.toUpperCase()
            axios({
                method: 'post', //you can set what request you want to be
                url: userAPIRoot+'/users/login',
                data: this.input
                })
            .then((respuesta) => {

                console.log(respuesta.data['token'])
                let token = respuesta.data['token']
                this.$cookie.set('token', respuesta.data['token'])
                this.user = jwt_decode(this.$cookie.get('token'))
                
                if(!this.user.isAdmin){

                    axios.defaults.headers.common['Authorization'] = `Bearer ${ token }`;

                    axios.get(userAPIRoot+'/users/'+this.user._id+'/companyUsers')
                    .then((resp)=>{ 
                        //console.log('resp', resp)
                        axios.get(userAPIRoot+'/companies/'+resp.data[0].company)
                        .then((company)=>{
                            //console.log('company', company)
                            axios.get(userAPIRoot+'/companies/'+company.data._id+'/positions')
                            .then((position)=>{

                                for (let i = 0; i < position.data.length; i++) {
                                   if(position.data[i]._id == resp.data[0].position){
                                       this.$session.set('position', position.data[i].name)
                                       this.$session.set('positionId', position.data[i]._id)
                                   }
                                    
                                }
                                // console.log('position', position)
                                if(company.data.admins.includes(this.user._id)){
                                    this.$session.set('isAdmin', 'yes' )
                                }else{
                                    this.$session.set('isAdmin', 'no' )
                                }
                                this.$session.set('companyId', company.data._id)
                                this.$session.set('companyName', company.data.name)
                                this.$session.set('userId', this.user._id )
                                this.$session.set('name', this.user.firstNames )
                                this.$session.set('lastname', this.user.lastNames )
                                this.$session.set('isSuperAdmin', this.user.isAdmin )
                                this.loading = false

                                if(this.$session.get('isAdmin') == 'yes'){
                                    this.$router.push({ name: "adminDashboard" })
                                }else {
                                    this.$router.push({ name: "wellcome" })
                                }
                            })
                        })
                    })
                }else {
                    this.$session.set('userId', this.user._id )
                    this.$session.set('name', this.user.firstNames )
                    this.$session.set('lastname', this.user.lastNames )
                    this.$session.set('isSuperAdmin', this.user.isAdmin )
                    this.$session.set('position', 'Administrador' )
                    this.loading = false
                
                    this.$router.push({ name: "Dashboard" });   
                }
                //console.log(this.$cookie.get('token'))
            })
            .catch((error)=>{
                this.loading = false
                this.$message({
                    message: 'Datos ingresados no válidos',
                    type: 'error',
                    showClose: true,
                });
                
            })
        },
        getParameterByName(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }
    },
    mounted() {
        //console.log('url', userAPIRoot)
        if(this.getParameterByName('token')){
            this.$cookie.set('token', this.getParameterByName('token'))
            this.user = jwt_decode(this.$cookie.get('token'))
            if(!this.user.isAdmin){

                axios.get(userAPIRoot+'/users/'+this.user._id+'/companyUsers')
                .then((resp)=>{ 
                    
                    axios.get(userAPIRoot+'/companies/'+resp.data[0].company)
                    .then((company)=>{
                        //console.log(company.data._id)
                        if(company.data.admins.includes(this.user._id)){
                            this.$session.set('isAdmin', 'yes' )
                        }else{
                            this.$session.set('isAdmin', 'no' )
                        }
                        this.$session.set('companyId', company.data._id)
                        this.$session.set('userId', this.user._id )
                        this.$session.set('name', this.user.firstNames )
                        this.$session.set('lastname', this.user.lastNames )
                        this.$session.set('isSuperAdmin', this.user.isAdmin )
                        this.loading = false
                    
                        if(this.$session.get('isAdmin') == 'yes'){
                           this.$router.push({ name: "adminDashboard" })
                        }else {
                           this.$router.push({ name: "wellcome" })
                        }
                    })
                })

                }else {
                    this.$session.set('userId', this.user._id )
                    this.$session.set('name', this.user.firstNames )
                    this.$session.set('lastname', this.user.lastNames )
                    this.$session.set('isSuperAdmin', this.user.isAdmin )
                    this.loading = false
                
                    this.$router.push({ name: "Dashboard" });
                    
                }
            
            //this.$router.push({ name: "wellcome" });
        }
    }
}
</script>

<style>

#login-container {
    width: 300px;
    background-color: #fff;
    border-radius: 8px;
    padding: 30px;
    margin-left: 250px;
}

#main-cont{
    max-width: 1300px;
    margin: 0 auto;
}

#rut-info {
    font-size: 14px;
    color: #005EB8;
    margin-left: 10px;
}

#login-container-title {
   margin: 0;
   font-size: 28px;
   font-weight: 900;
}

#land-p {
    color: rgba(6, 13, 22, 0.4);
    font-weight: 900;
}

#label {
    color: #005EB8;
    font-weight: 600;
}

#login-container-input{
    border: 0;
    border-bottom: 1px solid #005EB8;
    height: 30px;
    margin-bottom: 10px;
}

#main-row {
    background-image: url('../../assets/images/landing.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 500px;
    padding-top: 80px;
}

#land-back {
    background-color: #fff;
    padding: 0;
}

#land-content {
    background-color: #fff;
    max-width: 1300px;
    margin: 0 auto;
    padding: 0;
}

#our-plataform {
    text-align: center;
    padding: 100px 300px;
    
}

#main-title {
    color: #005EB8;
    font-size: 30px;
}

#main-title2 {
    color: #fff;
    font-size: 30px;
}

#course-land{
    color: #fff;
    padding: 50px 30px;
    font-size: 20px;
}

#main-subtitle {
    color: #005EB8;
    font-size: 20px;
}

#features {
    text-align: center;
    padding: 50px 30px;
}

#some-courses {
    text-align: center;
    padding: 50px 100px;
    background-color: rgb(241, 241, 241);
    margin: 50px 0;
}

#img-container {
    margin: 0 auto;
    max-width: 300px;
    height: 180px;
    background: linear-gradient(to right,#001736,#005EB8);
    box-shadow: 0px 2px 10px rgba(162, 166, 163, 0.25);
    border-radius: 8px;
    margin-top: 30px;
}

#land-img {
    max-width: 240px;
    background: linear-gradient(to right,#001736,#005EB8);
    box-shadow: 0px 2px 10px rgba(162, 166, 163, 0.25);
    border-radius: 8px;
}

#course-section{
    background-color: #63C3D7;
}

#img-container:hover {
   transform: scale(1.1);
   transition: all .2s ease-in-out;
}

#contact {
    text-align: center;
    padding: 50px 300px;
}

#contact-input {
    padding: 5px;
}

#footer {
    text-align: center;
    padding: 20px;
    border-top: 1px solid rgba(171, 174, 179, 0.3);
}

#logo-login {
    margin: 0px;
    width: 120px;
}
#login {
    background: linear-gradient(to right,#001736,#005EB8);
    color: #fff;
    font-size: 14px;
    font-weight: 400;
}

#support {
    max-width: 460px;
    margin: 0 auto;
}

#phone {
    border-top: 1px solid rgba(171, 174, 179, 0.3);
    border-bottom: 1px solid rgba(171, 174, 179, 0.3);
}

#land-phone {
    color: rgba(6, 13, 22, 0.4);
    font-weight: 600;
    font-size: 13px;
    margin: 5px;
}

#phone-number {
    margin: 5px;
}

@media only screen and (max-width: 1285px) {
    
}
/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/
@media (max-width:991px) and (min-width:768px){
    
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/
@media (max-width:767px){

    #login-container {
        width: 100%;
        max-width: 230px;
        background-color: #fff;
        border-radius: 8px;
        padding: 30px;
        margin: 0 auto;
    }

    #main-cont{
        max-width: 1300px;
        margin: 0 auto;
    }

    #login-container-title {
        margin: 0;
        font-size: 28px;
        font-weight: 900;
    }

    #land-p {
        color: rgba(6, 13, 22, 0.4);
        font-weight: 900;
    }

    #land-back {
        background-color: #fff;
    }

    #land-content {
        background-color: #fff;
        max-width: 1300px;
        margin: 0 auto;
        padding: 0px 10px;
        text-align: center;
    }

    #main-content {
        padding: 25px 10px;
    }

    #main-title {
        margin-top: 25px;
        font-size: 35px;
    
    }

    #our-plataform {
        text-align: center;
        padding: 25px 20px;
    }

    #features {
        text-align: center;
        padding: 25px 20px;
    }

    #some-courses {
        text-align: center;
        padding: 25px 20px;
    }

    #img-container {
        margin: 0 auto;
        max-width: 300px;
        height: 180px;
        background: linear-gradient(to right,#001736,#005EB8);
        box-shadow: 0px 2px 10px rgba(162, 166, 163, 0.25);
        border-radius: 8px;
        margin-top: 30px;
    }

    #course-land {
        font-size: 18px;
        padding: 60px 20px 0px;
        color: #fff;
    }

    #land-img {
        max-width: 200px;
        box-shadow: 0px 2px 10px rgba(162, 166, 163, 0.25);
        border-radius: 8px;
    }

    #land-img:hover {
        transform: scale(1.1);
    }

    #contact {
        text-align: center;
        padding: 25px 20px;
    }

    #contact-input {
        padding: 5px;
    }

    #footer {
        text-align: center;
        padding: 20px;
    }

    #logo-login {
        margin: 0px;
        width: 120px;
    }
    #login {
        background: linear-gradient(to right,#001736,#005EB8);
        color: #fff;
        font-size: 14px;
        font-weight: 400;
        text-align: center
    }
    
}

</style>



// WEBPACK FOOTER //
// src/components/login/loginComponent.vue